module.exports = __webpack_public_path__ + "38537c41664b55a40b79e859cd3488e8.svg";